import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rensningsanlæg",
  "use": "rensningsanlæg-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"rensningsanlæg\"><path d=\"M444.84 83.16C398.036 32.052 330.763 0 256 0 114.615 0 0 114.615 0 256h48c0-114.875 93.125-208 208-208 61.51 0 116.771 26.709 154.848 69.153L336 192h176V16l-67.16 67.16zM464 256c0 114.875-93.125 208-208 208-61.51 0-116.771-26.709-154.847-69.153L176 320H0v176l67.16-67.16C113.964 479.948 181.237 512 256 512c141.385 0 256-114.615 256-256h-48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/rensningsanlæg.svg
// module id = /NKn
// module chunks = 1